import React from "react";

const HowItWorks = () => {
  return (
    <div
      id="how-it-works-2"
      className="how-it-works container trading_meets_collectibles"
    >
      <div className="container">
        <div className="about-gangsta">
          <p className="about-title">Trading Collectibles Meet Blockchain: </p>
          <p className="about-subtitle">
            GangstaBet was inspired by the classic gangster movies from the 90s,
            entailing a constant battle between gangsters and detectives. Each
            character tells a unique story about their life as they try to climb
            to the helm. From a Casino Worker to a Mob Boss, or a Junior
            Detective to a Chief Constable, GangstaBet writes their entire
            journey on the blockchain.
            <br />
            <br />
            Unlike other collectibles, buyers have full ownership and control
            over their GangstaBet’s evolution. The skills of a GangstaBet can be
            increased by burning $GBET. As you increase your character’s skills,
            you will move up the ranks within the world of gangsters and
            detectives, with the ultimate goal of becoming a global Mob Leader
            or Chief Constable. As you move up the ranks, it will become
            increasingly difficult to reach the top of the game. In addition,
            buyers will be able to change the name of their GangstaBet. The
            names of every GangstaBet will be unique, which means that no two
            characters can ever share the same name.
            <br />
            <br />
            As the supply of $GBET decreases over time, changing the name and
            skills will become a scarce commodity. This intrinsic rarity is
            crucial as GangstaBets with higher levels will start becoming more
            valuable. This will influence how the characters will evolve in
            2030. The team at GangstaBet conceptualized the art but to complete
            this truly immersive digital collectible, the responsibility has
            been passed on to the participants.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
